import { Report19202Container } from "../../../containers/borrowSystem/Report/Report19202Container";

export function Report19202Page() {
    return (
        <Report19202Container />
    )
}